const campaignRequest: Record<string, Record<string, string> | string> = {
    printFormsTable: {
        crcCode: 'CRC-code',
    },
    errorTextForRequest:
        'Check the completion of the required fields of the application and the correctness of the entered values. Sections with errors are marked with a red exclamation mark to the right of the application form',
};

export default campaignRequest;
